<script setup>
import {computed, watch, onUnmounted} from 'vue'
import {useComponentFieldsStore} from '@/stores/componentFields'
import {useComponentsStore} from '@/stores/components'
import {useFieldsetsStore} from '@/stores/fieldsets'
import ContentTypeFieldEditForm from '@/common/content-type/ContentTypeFieldEditForm'
import ContentTypeNewAttributeBtn from '@/common/content-type/ContentTypeNewAttributeBtn'
import ContentTypeFieldsList from '@/common/content-type/ContentTypeFieldsList'
import ContentTypeFieldsetsList from "@/common/content-type/ContentTypeFieldsetsList.vue"
import ContentTypeNewFieldsetBtn from "@/common/content-type/ContentTypeNewFieldsetBtn.vue"
import ContentTypeFieldsetOffcanvas from "@/common/content-type/ContentTypeFieldsetOffcanvas.vue"
import {useRoute} from "vue-router"

const route = useRoute()

const componentFieldsStore = useComponentFieldsStore()
const componentsStore = useComponentsStore()
const fieldsetsStore = useFieldsetsStore()

// --- Computed ---

const fieldsetId = computed(() => parseInt(route.params.fieldsetId))
const fieldId = computed(() => parseInt(route.params.fieldId))
const tableName = computed(() => route.params.component)

const componentId = computed(() => {
    return componentsStore.componentIds[tableName.value]
})

const activeEditId = computed(() => componentFieldsStore.activeEditId)
const hasFieldsets = computed(() => fieldsetsStore.items?.length || 0)
const activeFieldsetId = computed(() => componentFieldsStore.activeFieldsetId)

// --- Watchers ---

// Synchronize Route Params with Store State
watch(fieldsetId, (val) => {
    componentFieldsStore.activeFieldsetId = val
}, {immediate: true})

watch(fieldId, (val) => {
    componentFieldsStore.activeEditId = val
}, {immediate: true})

// Initialize fields when switching components (e.g., /users/fields -> /products/fields)
watch(componentId, (val) => {
    if (val) {
        componentFieldsStore.init({componentId: val})
    }
}, {immediate: true})

// Refresh fields if the active fieldset changes
watch(activeFieldsetId, () => {
    if (componentId.value) {
        componentFieldsStore.init({componentId: componentId.value})
    }
})

// --- Lifecycle ---

onUnmounted(() => {
    componentFieldsStore.$reset()
})
</script>

<template>
    <div class="pt-4 px-3 d-flex h-100 overflow-auto">
        <div class="row d-flex h-100 overflow-auto flex-fill">
            <template v-if="hasFieldsets">
                <div class="col-3 col-lg-2 pb-3 overflow-auto h-100">
                    <ContentTypeFieldsetsList class="mb-3"/>
                    <ContentTypeNewFieldsetBtn/>
                    <ContentTypeFieldsetOffcanvas/>
                </div>

                <div v-if="fieldsetId" class="col-3 col-lg-2 pb-3 overflow-auto h-100">
                    <ContentTypeFieldsList class="mb-3"/>
                    <ContentTypeNewAttributeBtn/>
                </div>

                <div class="col-6 col-lg-8 overflow-auto h-100">
                    <ContentTypeFieldEditForm v-if="activeEditId >= 0"/>
                </div>
            </template>

            <template v-else>
                <div class="col-sm-3 overflow-auto h-100">
                    <ContentTypeFieldsList/>
                    <ContentTypeNewAttributeBtn/>
                </div>

                <div class="col-sm-9 overflow-auto h-100">
                    <ContentTypeFieldEditForm v-if="activeEditId >= 0"/>
                </div>
            </template>
        </div>
    </div>
</template>

<style scoped>
.ghost {
    background: #666;
    border-color: #666;
    color: #fff;
}
</style>